import db from '../database';

export default (model) => () => db[model];
